import { formatDate, getTime, convertSecondsToDays, statusTitle } from '@/helpers/format-date';
import i18n from '@/api/i18n/i18n';
import { action } from '@/components/pages/computers/log/computer/utils';
import { getCategoryName } from '@/helpers/methods';

export const PRODUCTIVITY_VALUE = {
  0: i18n.t('reports.unproductive'),
  1: i18n.t('reports.productive'),
  2: i18n.t('reports.neutral'),
  4: i18n.t('reports.browser'),
};

export const PRODUCTIVITY_DETAILS_VALUE = {
  1: i18n.t('reports.columns.activeTime'),
  4: i18n.t('reports.columns.idleTime'),
};

const CONVERT_FIELDS = [
  'activeTime',
  'idleTime',
  'productiveTime',
  'unproductiveTime',
  'neutralTime',
  'overwork',
  'plan',
  'workTime',
  'worktime',
  'duration',
  'aveWorking',
  'productive',
  'notProductive',
  'meetings',
  'workPlan',
  'holidayWork',
];
const mapConvertFields = new Set(CONVERT_FIELDS);

export function getDataField(data, field) {
  if (mapConvertFields.has(field)) return convertSecondsToDays(data);

  const fieldValue = {
    action: (val) => action(val),
    group: (val) => {
      const key = `db.${val}`;
      return i18n.te(key) ? i18n.t(key) : val;
    },
    activePercent: (val) => val.toFixed(2),
    dayStart: (val) => getTime(val),
    dayFinish: (val) => getTime(val),
    isWorkingDay: (val) => (val ? i18n.t('reports.working') : i18n.t('reports.dayOff')),
    eventTime: (val) => `${formatDate(val)} `,
    productivity: (val) => PRODUCTIVITY_VALUE[val] || '',
    productivityDetails: (val) => PRODUCTIVITY_DETAILS_VALUE[val] || '',
    productivityStatus: (val) => statusTitle(val),
    categoryName: (val) => getCategoryName(val),
  };

  return fieldValue[field] ? fieldValue[field](data) : data;
}
